import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useStore } from '@nuxtjs/composition-api';
import DropdownMenu from '~/components/DropdownMenu.vue';
import { useUser } from '~/composables/useUser';
import { State } from '~/store';
import { ExperimentTypes } from '~/types/experiments';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileDropdown',
  setup(__props) {

const store = useStore<State>();
const { user } = useUser();
const { $isFlagOn, $intercom, $mzAnalyticsApi } = useContext();
const deviceId = computed(() => store.getters.deviceId);

const trackClick = (name: string) => {
  $mzAnalyticsApi({
    event: 'click',
    name,
    productArea: 'profile',
  });
};

const logout = async () => {
  try {
    const logoutResponse = await store.dispatch('logout');
    trackClick('profile.log_out');
    if (logoutResponse) {
      if (typeof $intercom !== 'undefined') {
        $intercom.shutdown();
      }
    }
  } catch (err) {
    store.dispatch('setToast', {
      content: 'Something went wrong when trying to log you out. Please refresh and try again.',
    });
  }
};

return { __sfc: true,store, user, $isFlagOn, $intercom, $mzAnalyticsApi, deviceId, trackClick, logout, DropdownMenu, ExperimentTypes }
}

})